import InstantCardModal from "./InstantCardModal";
export default InstantCardModal;
